import React from 'react';


export default class Foco90 extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;

    return(
      <div>
        <strong>Em que consiste o Foco90 ? E pelo que estou pagando?</strong><br /><br />
        1 - Método criado por Roberto Jacob, baseado em comprovação científica e 20 anos de experiência;<br /><br />
        2 - Programa de treino online <br /><br />
        3 - Treinos novos semanais com opção de emagrecimento ou hipertrofia <br /><br />
        4 - Treinos em casa para quem não vai à academia <br /><br />
        5 - Vídeos dos exercícios como padrão de movimento.<br /><br />
        <strong>Bônus!!</strong><br /><br />
        O Que são os bônus? Bônus são suplementos em conteúdo para beneficiar os clientes sem que tenham que pagar mais por isso.<br /><br />
        1 - ebooks disponíveis na plataforma;<br /><br />
        2 - grupo Exclusivo de clientes no Facebook para suporte, onde você pode tirar todas as suas dúvidas, inclusive postar fotos e vídeos da sua execução para correções. O grupo também conta com nutricionista.<br /><br />
        {/*3 - suporte profissional / Personal Trainer para você postar suas dúvidas e seus vídeos no grupo fechado do facebook, depois de ler os conteúdos;<br /><br />*/}
        3 - orientação nutricional padrão.<br /><br />
        Estamos trabalhando pra criar sempre mais por menos.<br /><br />
        Obrigado por fazer Parte disso tudo!!<br /><br />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Foco90.js